module.exports = require('graphql-tag');
